const SIGNUP_SESSION_COOKIE = "fbc_signup_session";
const SIGNIN_POST_LOGIN_REDIRECT_QUERY_PARAM = "postSigninRedirect";
const SIGNUP_REFERRAL_CODE_COOKIE = "fbc_signup_referral_code";

export { SIGNIN_POST_LOGIN_REDIRECT_QUERY_PARAM, SIGNUP_REFERRAL_CODE_COOKIE, SIGNUP_SESSION_COOKIE };
//# sourceMappingURL=auth.config.js.map
